<template>
    <v-expansion-panels>
        <v-expansion-panel>
            <v-expansion-panel-header color="#6499faff" style="color: white;">
                {{ $t('coachPayment.title') }}
                <span class="ml-5">{{ payment && payment.startDate && payment.endDate ? getDate(payment.startDate) + ' ~ ' + getDate(payment.endDate) : '' }}</span>
                <span class="ml-5" :style="payment && parseInt(payment.pendingAmount) === 0 ? 'color: green' : ''">{{ payment && payment.amount ? $t('coachPayment.paid') + ': ' + payment.amount : '' }}</span>
                <span :style="payment && parseInt(payment.pendingAmount) > 0 ? 'color: red' : ''">{{ payment && payment.pendingAmount ? ' (' + $t('coachPayment.pending') + ': ' + payment.pendingAmount + ')' : '' }}</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-form :readonly="readOnly">
                    <v-row>
                        <v-col cols="6" lg="4">
                            <date-time-picker
                                :date-label="$t('form.startDate')"
                                :date="startDate"
                                @setDate="setStartDate"
                            />
                        </v-col>
                        <v-col cols="6" lg="3">
                            <date-time-picker
                                :date-label="$t('form.endDate')"
                                :date="endDate"
                                @setDate="setEndDate"
                            />
                        </v-col>
                        <v-col cols="6" lg="4">
                            <v-text-field
                                v-model="payment.amount"
                                :label="$t('coachPayment.amount')"
                                :clearable="clearable"
                            />
                        </v-col>
                        <v-col cols="6" lg="4">
                            <v-text-field
                                v-model="payment.pendingAmount"
                                :label="$t('form.pendingAmount')"
                                :clearable="clearable"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import momentTimezone from 'moment-timezone'
    import DateTimePicker from '@/components/DateTimePicker'

    export default {
        name: 'CoachPaymentForm',
        components: {
            DateTimePicker
        },
        props: {
            payment: {
                type: Object,
                required: true
            }
        },
        data: () => {
            return {
                mode: null,
                readOnly: false,
                clearable: true,
                loading: false,
                startDate: null,
                endDate: null,
                mandatoryField: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        computed: {
        },
        created() {
            if (this.payment.startDate) {
                this.startDate = momentTimezone(this.payment.startDate).tz('Europe/Athens').format('YYYY-MM-DD')
            }
            if (this.payment.endDate) {
                this.endDate = momentTimezone(this.payment.endDate).tz('Europe/Athens').format('YYYY-MM-DD')
            }
        },
        methods: {
            setStartDate(date) {
                this.payment.startDate = momentTimezone(date).tz('UTC').toISOString()
            },
            setEndDate(date) {
                this.payment.endDate = momentTimezone(date).tz('UTC').toISOString()
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            getDate(date) {
                return momentTimezone(date).tz('Europe/Athens').format('YYYY-MM-DD').toString()
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.v-menu__content{
    background-color: white!important;
    overflow-y: hidden!important;
}
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
</style>
